import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import styles from './index.module.scss';
import AccountInfo from './AccountInfo/accountInfo';
import SubscriptionInfo from './SubscriptionInfo/subscriptionInfo';
import BillingInfo from './BillingInfo/billingInfo';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import config from 'config';
import Services from './Services/services';
import Products from './Products/products';
import { ADMIN_PAGE } from 'utils/constants/css';
const stripe = loadStripe(config.stripePublishableKey);

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
    overflow: 'scroll',
    height: ADMIN_PAGE.HEIGHT,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.primary,
    background: theme.palette.background.default,
    width: '100%',
  },
}));

const Account = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={styles.container}>
        <div className={styles.accInfo}>
          <Paper className={classes.paper}>
            <AccountInfo />
          </Paper>
        </div>
        <div className={styles.services}>
          <Paper className={classes.paper}>
            <Services />
          </Paper>
        </div>
        <div className={styles.products}>
          <Paper className={classes.paper}>
            <Products />
          </Paper>
        </div>
        <div className={styles.overview}>
          <div className={styles.subscriptionOverview}>
            <Paper className={classes.paper}>
              <SubscriptionInfo />
            </Paper>
          </div>
          <div className={styles.billing}>
            <Paper className={classes.paper}>
              <Elements stripe={stripe}>
                <BillingInfo />
              </Elements>
            </Paper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
